import { PropsWithChildren } from 'react';
import './body-top-bar.component.scss';

export const BodyTopBarComponent = ({ children }: PropsWithChildren) => {
  return <div className="top-bar-component">{children}</div>;
};
